import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSparkleCentral: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSparkleCentral"><Path d="M13 2H11L8.5 8.5L2 11V13L8.5 15.5L11 22H13L15.5 15.5L22 13V11L15.5 8.5L13 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSparkleCentral;
